import ImagesDownloadAppAppStorePng from '@/public/images/download-app/app-store.png';
import ImagesDownloadAppAppleSvg from '@/public/images/download-app/apple.svg';
import ImagesDownloadAppDownloadAppBackgroundMobile1Webp from '@/public/images/download-app/download-app-background-mobile-1.webp';
import ImagesDownloadAppDownloadAppMobileHandSvg from '@/public/images/download-app/download-app-mobile-hand.svg';
import ImagesDownloadAppDownloadAppMobileWebp from '@/public/images/download-app/download-app-mobile.webp';
import ImagesDownloadAppDownloadAppOnlyHandMobileWebp from '@/public/images/download-app/download-app-only-hand-mobile.webp';
import ImagesDownloadAppGooglePlaySvg from '@/public/images/download-app/google-play.svg';
import ImagesDownloadAppHandMockupWebp from '@/public/images/download-app/hand-mockup.webp';
import ImagesDownloadAppIphoneXBesidesMacbookProMockupTemplatePng from '@/public/images/download-app/iphone-x-besides-macbook-pro-mockup-template.png';
import ImagesDownloadAppMockupAppSvg from '@/public/images/download-app/mockup-app.svg';
import ImagesDownloadAppPlayStorePng from '@/public/images/download-app/play-store.png';
import ImagesDownloadAppQrPng from '@/public/images/download-app/qr.png';
import ImagesDownloadAppQrSvg from '@/public/images/download-app/qr.svg';

export {
  ImagesDownloadAppAppStorePng,
  ImagesDownloadAppAppleSvg,
  ImagesDownloadAppDownloadAppBackgroundMobile1Webp,
  ImagesDownloadAppDownloadAppMobileHandSvg,
  ImagesDownloadAppDownloadAppMobileWebp,
  ImagesDownloadAppDownloadAppOnlyHandMobileWebp,
  ImagesDownloadAppGooglePlaySvg,
  ImagesDownloadAppHandMockupWebp,
  ImagesDownloadAppIphoneXBesidesMacbookProMockupTemplatePng,
  ImagesDownloadAppMockupAppSvg,
  ImagesDownloadAppPlayStorePng,
  ImagesDownloadAppQrPng,
  ImagesDownloadAppQrSvg,
};
